module.exports = __webpack_public_path__ + "img/de-cooded-logo.3c68ae48.png";